import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-credit-card-overview _mt-2",
  "data-qa": "card-overview"
}
const _hoisted_2 = {
  class: "gfu-credit-card-overview__label _mr-1",
  "data-qa": "masked-card-number"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_image, {
      src: $props.imageUrl,
      alt: $props.name,
      class: "_mr-2",
      "data-qa": "card-image"
    }, null, 8 /* PROPS */, ["src", "alt"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString($props.maskedNumber), 1 /* TEXT */),
    _createElementVNode("a", {
      href: "",
      class: "gfu-link gfu-link--accent",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onDelete && $options.onDelete(...args)), ["prevent"])),
      "data-qa": "card-remove-button"
    }, _toDisplayString(_ctx.Resources.AccountSettings.DeleteCreditCardButton), 1 /* TEXT */)
  ]))
}